function setSectionColorProperties(sectionColor) {
  document.documentElement.style.setProperty(
    "--color-scheme-text-override",
    `var(--color-${sectionColor}-text)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-text-overlay-override",
    `var(--color-${sectionColor}-text-overlay)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-background-override",
    `var(--color-${sectionColor}-background)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-accent-overlay-override",
    `var(--color-${sectionColor}-accent-overlay)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-accent-override",
    `var(--color-${sectionColor}-accent)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-meta-override",
    `var(--color-${sectionColor}-meta)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-solid-button-background-override",
    `var(--color-${sectionColor}-solid-button-background)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-solid-button-text-override",
    `var(--color-${sectionColor}-solid-button-text)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-solid-button-background-hover-override",
    `var(--color-${sectionColor}-solid-button-background-hover)`
  );

  document.documentElement.style.setProperty(
    "--color-scheme-solid-button-text-hover-override",
    `var(--color-${sectionColor}-solid-button-text-hover)`
  );

  document.documentElement.style.setProperty(
    "--icon-svg-select-override",
    `var(--icon-svg-select-${sectionColor})`
  );

  document.documentElement.style.setProperty(
    "--icon-svg-arrow-right-override",
    `var(--icon-svg-arrow-right-${sectionColor})`
  );
}

function setLogo(color) {
  if (!color) color = "primary";
  document.querySelectorAll(".logo-container").forEach((logo) => {
    if (logo.classList.contains("logo-" + color)) {
      logo.classList.add("logo-container--active");
    } else {
      logo.classList.remove("logo-container--active");
    }
  });
}

const sectionIOCallback = function (entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("in-view");
    } else {
      entry.target.classList.remove("in-view");
    }
  });

  const inViewSections = document.querySelectorAll(
    "section[data-color-scheme].in-view"
  );

  const inViewColorSchemes = [];

  inViewSections.forEach((section) => {
    inViewColorSchemes.push(section.dataset.colorScheme);
  });

  setSectionColorProperties(inViewColorSchemes[0]);
  /* 
    BUGFIX: Basicaly there is a bug in the theme if header is noet overlay for some pages.
    Headers background will be white and logo will be white too. So we need to check if header is not overlay,
    and if it is we need to set logo to be header property unless scrolled 40px down
  */
  const header = document.querySelector(".header-main-section");
  //get header color scheme
  const headerColorScheme = header.querySelector(".js-header")
    ? header.querySelector(".js-header").dataset.selectedColorScheme
    : inViewColorSchemes[0];
  //check if header has "absolute" class
  if (header.classList.contains("absolute")) {
    setLogo(inViewColorSchemes[0]);
  } else {
    if (header.classList.contains("absolute")) return;
    setLogo(headerColorScheme);
    //if header is not absolute check if we are scrolled more than 40px down
    window.addEventListener("scroll", () => {
      if (header.classList.contains("absolute")) return;
      if (window.scrollY > 40 || header.classList.contains("absolute")) {
        setLogo(inViewColorSchemes[0]);
      } else {
        setLogo(headerColorScheme);
      }
    });
  }
};

const sectionIOOptions = {
  root: null,
  rootMargin: "-19% 0px -19% 0px",
  threshold: 0.001,
};

const sectionIO = new IntersectionObserver(sectionIOCallback, sectionIOOptions);

const sectionSelector =
  "section[data-color-scheme]:not(.disable-section-color-transition-source)";

document.querySelectorAll(sectionSelector).forEach((section) => {
  sectionIO.observe(section);
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target.querySelector(sectionSelector);

    if (section) {
      sectionIO.observe(section);
    }
  });

  document.addEventListener("shopify:section:unload", (e) => {
    const section = e.target.querySelector(sectionSelector);

    if (section) {
      sectionIO.unobserve(section);
    }
  });
}
